<template>
    <div>
      <v-row class="sector-head py-0">
          <v-col cols="12" class="primary_blue--text subtitle-1 font-weight-bold">
              <p class="mb-0 ml-4"> Líneas de {{invoice.name}} </p> 
          </v-col>
      </v-row>
      <v-card
          flat
          width="100%"
          class="text-center lines__table"
          style="overflow-y:scroll"
        >
          <!-- {{ invoice_lines }} -->
          <v-row class="table-head-row flex-sm-nowrap d-flex align-center justify-center" no-gutters>
              <v-col cols="9">Descripcion</v-col>
              <v-divider vertical></v-divider>
              <div class="col" cols="1">Precio Unitario</div>
              <v-divider vertical></v-divider>
              <div class="col" cols="1">Cantidad</div>
              <v-divider vertical></v-divider>
              <div class="col" cols="1">Importe total</div>
          </v-row>
  
          <div no-gutters v-for="(invoice_line, index) in invoice_lines" v-bind:key="index"  >
              <div class="d-flex flex-sm-nowrap table-row">
                    <v-col cols="9"  class=" pa-0 ma-0 d-flex flex-sm-nowrap">
                        <div class="d-flex align-center justify-center">
                            <v-btn icon color="#4c4c4c" @click="deleteInvoiceLine(index)" :disabled="readonly" >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                        <v-divider vertical></v-divider>
                        <div class="d-flex align-center justify-center px-2" :class="index % 2 == 0? 'bg__gray__2': 'bg__gray'">
                            {{ (index+1) }}
                        </div>
                        <v-divider vertical></v-divider>
                        <TableCustomTextField
                                :required="true"
                                v-model="invoice_line.description"
                                :kind="'invoice_line_kind'"
                                :readonly="readonly"
                        ></TableCustomTextField>
                    </v-col>
                  <v-divider vertical></v-divider>
                  <div class="col">
                      <TableCustomTextField
                          v-model="invoice_line.unit_price_without_tax" 
                          :required="true"
                          @change="change(index)"
                          :readonly="readonly"
                          :reverse="true"
                          :type="'number'"
                      ></TableCustomTextField>
                  </div>
                  <v-divider vertical></v-divider>
                  <div class="col">
                      <TableCustomTextField
                          @change="change(index)"
                          :required="true"
                          v-model="invoice_line.quantity" 
                          :readonly="readonly"
                          :reverse="true"
                          :type="'number'"
                      ></TableCustomTextField>
                  </div>
                  <v-divider vertical></v-divider>
                  <div class="col">
                      <TableCustomTextField 
                          :value="get_total_amount(invoice_line)"
                          readonly
                          :reverse="true"
                      ></TableCustomTextField>
                  </div>
              </div>
              <v-divider></v-divider>
          </div>
      </v-card>
  
    </div>
  </template>
  
  <script>
  import DocTextField from "../components/DocTextField.vue"
  import TableCustomTextField from "../components/layout/TableCustomTextField.vue"
  import AppRow from '@/components/layout/AppRow.vue';
  import AppCol from '@/components/layout/AppCol.vue';
  import AppBtn from '@/components/layout/AppBtn.vue';
  import { mapGetters } from "vuex";
  import {ExtraAmount} from '../modules/facturae/domain/Invoiceable'
  
  export default {
      name: "InvoiceLinesEditorSimplified",
      components: {
          DocTextField,
          AppRow,
          AppCol,
          AppBtn,
          TableCustomTextField
      },
  
      props:{
          invoice_lines: {
              type: Array,
              required: true
          },
          allow_import: {
              type: Boolean,
              required: false,
              default: false
          },
          loading: {
              type: Boolean,
              required: false,
              default: false
          },
          readonly: {
              type: Boolean,
              required: false,
              default: false
          },
          invoice: {
              type: Object,
              required: false,
          },
          products: {
              type: Array,
              required: false,
          }
      },
      data(){
          return {
              showAdditionalInfoDilog: false,
              ret_amount: undefined,
              ret_concept: undefined,
              discount_reason: undefined,
              discount_amount: undefined,
              reimbursable_expense: undefined,
              line_ivas: [
                  {name: '21%', value: 0.21},
                  {name: '10%', value: 0.10},
                  {name: '4%', value: 0.04},
                  {name: '0%', value: 0.00},
                  {name: '21% RE 5.2%', value: 0.052},
                  {name: '10% RE 1.4%', value: 0.014},
                  {name: '4% RE 0.5%', value: 0.005},
              ]
              ,
              line_retentions: [
                  {name: 'N/A', value: 'na'},
                  {name: '7%', value: 0.07},
                  {name: '15%', value: 0.15},
                  {name: '19%', value: 0.19},
              ],
              rest_products: this.products,
          }
      },
      computed: {
          ...mapGetters({ got_feature: "got_feature" }),
      },
      methods:{
          alternateGray(index){
              return index % 2 == 1 ? 'background-color: #eeeeee' : '#f2f2f2';
          },
          deleteInvoiceLine(index){
              this.$emit('delete-line',index);
          },
          change(index){
              this.$emit('change-line',index);
          },
          get_total_amount(invoice_line){
              return invoice_line.gross_amount
          },
          addInvoiceLine(){
              this.$emit('add-line');
          },
          ImportLinesFromExcel(){
              this.$emit('import-lines');
          },
          openDialogAdditionalInfo(){
              this.showAdditionalInfoDilog = true;
              this.ret_amount = this.invoice.retention_amount;
              this.ret_concept = this.invoice.retention_concept;
              if (this.invoice.general_discounts && this.invoice.general_discounts.length){
                  this.discount_reason = this.invoice.general_discounts[0].reason;
                  this.discount_amount = this.invoice.general_discounts[0].amount;
              }
              else{
                  this.discount_reason = undefined;
                  this.discount_amount = undefined;
              }
              if (this.invoice.reimbursable_amounts && this.invoice.reimbursable_amounts.length){
                  this.reimbursable_expense = this.invoice.reimbursable_amounts[0];
              }
              else{
                  this.reimbursable_expense = undefined;
              }
          },
          cancelChange(){
              this.showAdditionalInfoDilog = false;
          },
          changeAdditionaInfo(){
              this.invoice.retention_concept = this.ret_concept;
              this.invoice.retention_amount = this.ret_amount;
              if (this.discount_amount){
                  this.invoice.general_discounts = [new ExtraAmount(this.discount_reason, parseFloat(this.discount_amount))];
              }
              else{
                  this.invoice.general_discounts = [];
              }
              if (this.reimbursable_expense){
                  this.invoice.reimbursable_amounts = [parseFloat(this.reimbursable_expense)];
              }
              else{
                  this.invoice.reimbursable_amounts = [];
              }
              this.$emit('change-additional-info');
              this.showAdditionalInfoDilog = false;
          },
          tax_change(newRate, index){
              this.invoice_lines[index].selected_tax = newRate;
              this.$emit('change-line',index);
          },
          retention_change(newRate, index){
              this.invoice_lines[index].selected_retention = newRate;
              this.$emit('change-line',index);
          },
          product_changed(product_code, index) {
              let p = this.products.find(p => p.code === product_code);
              this.invoice_lines[index].selected_product = p;
              this.$emit('change-line',index);
          },
      },
  
  }
  </script>
  
  <style lang="scss" scoped>
      .primary-bckground {
          background-color: #663399;
      }
      .primary-border {
          border-color: #363636 !important;
      }
      .lines__table {
          font-size: 14px !important;
          width: 100% !important;
          max-height: 270px;
          padding: 0px !important;
          scrollbar-width: thin;
      }
      .table-head {
          border-color:#363636;
          background-color: #F4F4F4;
          height: 40px !important;
          font-weight: 600;
      }
      .table-right-head {
          background-color: #F4F4F4;
      }
      .table-head-row {
          position:sticky;
          top:0;
          z-index: 1;
          background-color: #F4F4F4;
          height: 40px !important;
          font-weight: 600;
      }
      .table-row .col, .table-row .v-text-field__slot > input{
          padding: 0px;
      }
      .footer {
        z-index: 101;
        max-height: 100%;
      }
      .bg__gray{
          background-color: rgba(217, 217, 217, 0.502);
      }
      .bg__gray__2 {
          background-color: #d9d9d9;
      }
  
      
  </style>
  